import { gql } from "@apollo/client";

export const GET_SUB_AREA_ATUACAO = gql`
query GetSubAreaAtuacao($pagination: Pagination) {
  GetSubAreaAtuacao(pagination: $pagination) {
    result {
      id
      name
    }
    pageInfo {
      totalPages
      totalItems
      hasPreviousPage
      hasNextPage
      currentPage
    }
  }
}
`